import { render, staticRenderFns } from "./PartakersList.vue?vue&type=template&id=2bc77dbb&scoped=true&"
import script from "./PartakersList.ts?vue&type=script&lang=ts&"
export * from "./PartakersList.ts?vue&type=script&lang=ts&"
import style0 from "./PartakersList.vue?vue&type=style&index=0&id=2bc77dbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc77dbb",
  null
  
)

export default component.exports